import { useLoginRedirect } from './hooks/use-login-redirect'
import { LoginTemplate } from './template'

export const Login = (): JSX.Element => {
  const { redirectTo, redirectingProvider } = useLoginRedirect()

  return (
    <LoginTemplate
      onProviderSignIn={redirectTo}
      loadingProvider={redirectingProvider}
    />
  )
}
